import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
  makeStyles
} from '@material-ui/core';
import { store } from 'src/_helpers';

const useStyles = makeStyles(() => ({
  root: {}
}));

const KeyGenrate = ({ className, ...rest }) => {
  const classes = useStyles();
  let { authentication } = store.getState();
  const [customers, setCustomer] = useState({
    apiKey: ''
  });
  useEffect(() => {
    // console.log('customers', customers, user);
    getdata();
  }, []);

  const getdata = async () => {
    let { user } = authentication;
    try {
      await fetch(
        process.env.REACT_APP_BASE_URL +
          `/v10/user/${user?.id}?token=${user?.token}`
      )
        .then(response => response.json())
        .then(data => {
          // setusera(data.results[0]);
          var u = data.results[0];
          console.log(u, 'user');
          setCustomer(u);
        });
    } catch (er) {
      console.log(er);
    }
  };

  const onSubmit = () => {
    var apiKey = customers.apiKey;
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: authentication.user.email,
        token: authentication.user.token,
        apiKey: apiKey
      })
    };
    fetch(
      process.env.REACT_APP_BASE_URL + `/v10/user/resetApiKey`,
      requestOptions
    )
      .then(handleResponse)
      .then(user => {
        let { results } = user;
        console.log('dasda', results);
        setCustomer({ apiKey: results });
      })
      .catch(err => {
        console.log(err);
      });
  };

  function handleResponse(response) {
    return response.text().then(text => {
      const data = text && JSON.parse(text);
      if (!response.ok) {
        if (response.status === 401) {
          // auto logout if 401 response returned from api
          // logout();
          // location.reload(true);
        }

        const error = (data && data.message) || response.statusText;
        return Promise.reject(error);
      }

      return data;
    });
  }

  return (
    <form
      autoComplete="off"
      noValidate
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Card>
        <CardHeader
          subheader="The information can only be Refreshed"
          title="Api Key"
        />
        <Divider />
        <CardContent>
          <Grid container spacing={10}>
            <Grid item md={12} xs={12}>
              <TextField
                fullWidth
                label="apiKey"
                name="apiKey"
                required
                contentEditable={false}
                value={customers.apiKey}
                variant="outlined"
              />
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <Box display="flex" justifyContent="flex-end" p={2}>
          <Button color="primary" variant="contained" onClick={onSubmit}>
            Refresh ApiKey
          </Button>
        </Box>
      </Card>
    </form>
  );
};

KeyGenrate.propTypes = {
  className: PropTypes.string
};

export default KeyGenrate;
